module.exports = __webpack_public_path__ + "img/error.2644b94b.jpg";